module.exports = "/images/blister-4.png";